import { Cell } from '@pelckmans/elementis/components/table';
import { useTranslation } from 'react-i18next';

const BASE_PATH = 'PAGES.RESULTS.SESSION_HISTORY_MODAL';

interface Props {
  isAssignment?: boolean;
  isAdaptive?: boolean;
}

export default function HistoryTableHeader({ isAssignment, isAdaptive }: Props) {
  const { t } = useTranslation();

  return (
    <thead>
      <tr>
        {isAssignment && (
          <Cell.HeaderText title={t(`${BASE_PATH}.TABLE_HEADER.SHARED`)} minWidth="sm" maxWidth="sm" sticky />
        )}
        <Cell.HeaderText title={t(`${BASE_PATH}.TABLE_HEADER.DATE_SUBMITTED`)} minWidth="sm" maxWidth="sm" sticky />
        {isAdaptive && (
          <Cell.HeaderText title={t(`${BASE_PATH}.TABLE_HEADER.PHASE`)} minWidth="lg" maxWidth="lg" sticky />
        )}
        <Cell.HeaderText title={t(`${BASE_PATH}.TABLE_HEADER.RESULTS`)} minWidth="xs" maxWidth="xs" sticky />
        <Cell.HeaderText title={t(`${BASE_PATH}.TABLE_HEADER.PERCENTAGE`)} minWidth="xs" maxWidth="xs" sticky />
        <Cell.HeaderText title={t(`${BASE_PATH}.TABLE_HEADER.SCORE`)} minWidth="sm" maxWidth="sm" sticky />
        <Cell.HeaderText title={t(`${BASE_PATH}.TABLE_HEADER.TIME_SPENT`)} minWidth="sm" maxWidth="sm" sticky />
        <Cell.HeaderEmpty className="actions-cell" sticky />
      </tr>
    </thead>
  );
}
